interface BellIconProps {
  unreadCount?: number;
}

export default function BellIcon({ unreadCount = 0 }: BellIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.57145 11.0622C4.25601 11.0622 4 10.8102 4 10.4997C4 8.04573 4.97073 5.73792 6.73376 4.00317C6.95698 3.78345 7.31902 3.78345 7.54224 4.00317C7.76546 4.2229 7.76546 4.57927 7.54224 4.799C5.99476 6.32143 5.14289 8.34566 5.14289 10.4997C5.14289 10.8102 4.88689 11.0622 4.57145 11.0622Z"
        fill="var(--primary)"
        stroke="var(--primary"
        strokeWidth="0.2"
      />
      <path
        d="M12.3812 21C10.8055 21 9.52393 19.7385 9.52393 18.1875C9.52393 17.877 9.77993 17.625 10.0954 17.625C10.4108 17.625 10.6668 17.877 10.6668 18.1875C10.6668 19.1183 11.4355 19.875 12.3812 19.875C13.3266 19.875 14.0955 19.1183 14.0955 18.1875C14.0955 17.877 14.3515 17.625 14.6669 17.625C14.9824 17.625 15.2384 17.877 15.2384 18.1875C15.2384 19.7385 13.9568 21 12.3812 21Z"
        fill="var(--primary"
        stroke="var(--primary"
        strokeWidth="0.2"
      />
      <path
        d="M18.6665 18.75H6.0947C5.35932 18.75 4.76123 18.1613 4.76123 17.4375C4.76123 17.0534 4.93116 16.6898 5.22762 16.44C6.38642 15.4762 7.04701 14.0753 7.04701 12.5911V10.5C7.04701 7.60506 9.43952 5.25 12.3806 5.25C15.3215 5.25 17.714 7.60506 17.714 10.5V12.5911C17.714 14.0753 18.3746 15.4762 19.5259 16.4348C19.8299 16.6898 19.9998 17.0534 19.9998 17.4375C19.9998 18.1613 19.4017 18.75 18.6665 18.75ZM12.3806 6.375C10.0696 6.375 8.18991 8.22523 8.18991 10.5V12.5911C8.18991 14.4067 7.38157 16.1212 5.97276 17.2935C5.94612 17.316 5.90412 17.3626 5.90412 17.4375C5.90412 17.5394 5.99104 17.625 6.0947 17.625H18.6665C18.77 17.625 18.8569 17.5394 18.8569 17.4375C18.8569 17.3626 18.8151 17.316 18.7898 17.295C17.3795 16.1212 16.5712 14.4067 16.5712 12.5911V10.5C16.5712 8.22523 14.6915 6.375 12.3806 6.375Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.2"
      />
      <path
        d="M12.3813 6.375C12.0658 6.375 11.8098 6.123 11.8098 5.8125V3.5625C11.8098 3.252 12.0658 3 12.3813 3C12.6967 3 12.9527 3.252 12.9527 3.5625V5.8125C12.9527 6.123 12.6967 6.375 12.3813 6.375Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.2"
      />
      {unreadCount && (
        <ellipse
          cx="16.0501"
          cy="6.5999"
          rx="2.74294"
          ry="2.7"
          fill="var(--primary)"
        />
      )}
    </svg>
  );
}
